// class EventsPage extends UIView
// {
//     constructor(events: LegacyEvent[], past: boolean)
//     {
//         super();
//         this.ui_add(new TLEventList('venue', 'list', 'event', events, {filter: past ? 'past' : 'active', sort: past ? 'past' : 'date'}));
//     }
// }

import { TLEventList } from '../lib/ab/event';
import { ABScreen } from '../lib/ab/screen';
import { aTrackPage } from '../lib/mdl/a-track';
import { legacyEventsGetVenueByCityAndSlug } from '../lib/mdl/zzz-legacy-open-events';
import { $el } from '../lib/ui/elements';
import { UIViewSpec } from '../lib/ui/view';
import { $id } from '../lib/y/types';
import { HomeMenu } from './menu';

// class InfoPage extends UIView
// {
//     constructor(venue: TLVenue)
//     {
//         super('div', 'u-columns');

//         const map_url = venue.static_map;
//         if(map_url) {
//             this.ui_add([$el.P('heading', 'Adress'), $el.A(venue.model.location, 
//                         [$el.IMG(map_url, undefined, venue.model.name), $el.DIV('r-icon'), $el.DIV('r-text', [$el.DIV('r-address', venue.model.address)])], 'tl-static-map')]);
//         }

//         this._addBlock('Om scenen', venue.model.description);
//         this._addBlock('Tillgänglighet', venue.model.texts['availability']);
//         this._addBlock('Mat och dryck', venue.model.texts['food']);
//     }

//     private _addBlock(title: string, text: string)
//     {
//         if(!text) return;
//         this.ui_add([
//             $el.P('heading', title),
//             $el.Ps('text', text.split('\n').filter(l => l))
//         ]);
//     }
// }

export class HomeVenueScreen extends ABScreen {
    constructor(private _city_slug: string, private _slug: string) {
        super({ menu: new HomeMenu });
    }

    protected override fillContent(content: UIViewSpec): void {
        legacyEventsGetVenueByCityAndSlug(this._city_slug, this._slug).then(data => {
            const venue = data.venue;
            let events = data.events;

            events = events.filter(e => !e.model.hide_in_search);

            content.ui_add($el.SECTION('w-block', [
                $el.P('bigtitle', venue.name),
                new TLEventList('venue', 'list', 'event', events, { filter: 'active', sort: 'date' })
            ]));

            aTrackPage('venue', { venue: $id.idToObjectId(venue.id) });
        });
    }
}
